(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.controller('NewAppointmentController', ['$rootScope', '$state', '$stateParams', 'UserService', '$location', 'ExternalPatientBroadcast', NewAppointmentControllerFn]);

    /* controller for agenda list - urgent */
    function NewAppointmentControllerFn($rootScope, $state, $stateParams, UserService, $location, ExternalPatientBroadcast) {

        const lowerCasedParams = Object.entries($location.search()).reduce(
            (acc, [key, val]) => (acc[key.toLowerCase()] = val, acc), {});

        // if careconnect gp --> userid is specified, otherwise firstname, lastname is provided
        if (lowerCasedParams.firstname && lowerCasedParams.lastname || lowerCasedParams.userid || lowerCasedParams.agendaid) {
            
            UserService.clearExternalPatient();
            UserService.setExternalPatientIncomingData(
                    lowerCasedParams.agendaid,
                    lowerCasedParams.userid,
                    lowerCasedParams.firstname, 
                    lowerCasedParams.lastname,
                    lowerCasedParams.phone,
                    lowerCasedParams.eyefileuserid,
                    lowerCasedParams.birthdate,
                    true); // patients from an external system are known
            $rootScope.$broadcast(ExternalPatientBroadcast.set);
        }

        $state.go('Home.Agenda_Day', $stateParams);
    }
})();